export default __webpack_public_path__ + "static/profile-management-38b68b6cb9aa98e113949ac7c7300c9f.png";